var _path, _circle, _path2, _circle2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0l10 12-10 12L2 12 12 0z",
    fill: "url(#infoIcon_svg__paint0_linear_45306_5836)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#infoIcon_svg__paint1_linear_45306_5836)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8h2v9l-1 2-1-2V8z",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 6,
    r: 1,
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "infoIcon_svg__paint0_linear_45306_5836",
    x1: 2,
    y1: 12.226,
    x2: 22,
    y2: 12.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#514DDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02A7DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "infoIcon_svg__paint1_linear_45306_5836",
    x1: 0,
    y1: 12.226,
    x2: 24,
    y2: 12.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#514DDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02A7DB"
  })))));
}

export default SvgInfoIcon;